import { Directive, ElementRef, HostListener, inject, input } from '@angular/core';
import { IMngNumberFormat } from '../input.types';

const numbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];

@Directive({
  selector: '[mngNumbersOnly]'
})
export class NumbersOnlyDirective {
  private element: HTMLInputElement;

  mngNumbersOnly = input<IMngNumberFormat>({ allowNegativeNumber: false, allowDecimals: false });

  constructor() {
    const elementRef = inject(ElementRef);

    this.element = elementRef.nativeElement;
  }

  @HostListener('keydown', ['$event'])
  keyDownEvent(event: KeyboardEvent) {
    if (event.ctrlKey && (event.key === 'c' || event.key === 'v' || event.key === 'C' || event.key === 'V')) {
      return;
    }

    // console.log('this.element.value', this.element.value, 'event.key', event.key);
    if ((event.key === 'm' || event.key === 'M') && this.element.value && this.element.value !== '') {
      // keys "m" oder "M" -> Million dazu
      this.setElementValue(`${this.element.value || ''}000000`, event);
    } else if ((event.key === 't' || event.key === 'T') && this.element.value && this.element.value !== '') {
      // keys "t" oder "T" -> Tausend dazu
      this.setElementValue(`${this.element.value || ''}000`, event);
    } else if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      // Arrow Up and Arrow Down ausschalten
      event.preventDefault();
    } else if (event.key === '-') {
      // 189 = '-' sign
      const containsMinusSign: boolean = this.element.value.indexOf('-') !== -1;
      if (this.mngNumbersOnly().allowNegativeNumber && !containsMinusSign) {
        this.setElementValue(`-${this.element.value || '0'}`, event);
      } else {
        event.preventDefault();
      }
    } else if (event.key === ',') {
      if (this.mngNumbersOnly().allowDecimals) {
        const containsDecimalSign: boolean = this.element.value.indexOf(',') !== -1;
        if (containsDecimalSign) {
          event.preventDefault();
        }
      } else {
        console.log('this');
        event.preventDefault();
      }
    } else if (event.key.length === 1 && !(event.key === 'Tab') && !numbers.includes(event.key)) {
      event.preventDefault();
    }
  }

  setElementValue(value: string, event: KeyboardEvent) {
    try {
      event.preventDefault();
      this.element.value = value;

      // Create a new 'change' event
      this.element.dispatchEvent(createNewEvent('change'));
    } catch (e) {
      console.error(e);
    }
  }
}

/**
 * "Sichere" Möglichkeit einen Event zu erzeugen (Support fuer IE)
 *
 * @param eventName
 */
function createNewEvent(eventName: string) {
  if (typeof Event === 'function') {
    return new Event(eventName);
  } else {
    // Event Erzeugung z.B. fuer IE
    const event = document.createEvent('Event');
    event.initEvent(eventName, true, true);
    return event;
  }
}
